import { AutoComplete, Input, Tag, Tooltip } from "antd";
import { useEffect, useState } from "react";
import useDebounce from "../UseDebounce/useDebounce";

const AutoCompleteFiltersInput = ({
  placeholder,
  functionSearch,
  filters,
  setFilters,
  entity,
  style,
  tagColor = "",
}) => {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState([]);
  const debouncedValue = useDebounce(query);

  useEffect(() => {
    if (debouncedValue) {
      functionSearch(debouncedValue, (res) => {
        const options_list = res.map((item) => {
          return {
            ...item,
            value: item.name ? item.name : item.value,
          };
        });
        setOptions([
          { value: debouncedValue, name: debouncedValue },
          ...options_list,
        ]);
      });
    }
  }, [debouncedValue]);
  const tagRender = (label) => {
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const onCloseTag = () => {
      const list = filters[`${entity}`].filter((item) => item !== label);
      setFilters({
        ...filters,
        [`${entity}`]: list,
      });
    };
    const isLongTag = label.length > 15;
    const tagElem = (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable
        onClose={onCloseTag}
        color={tagColor ? tagColor : ""}
      >
        {isLongTag ? `${label.slice(0, 15)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };
  const handleInputSearch = (value) => {
    setQuery(value);
  };
  const handleInputConfirm = (value, option) => {
    setFilters({
      ...filters,
      [`${entity}`]: filters[`${entity}`]
        ? [...filters[`${entity}`], `${option.value}`]
        : [`${option.value}`],
    });
    setQuery("");
  };
  const handleInputEnter = () => {
    setFilters({ ...filters, [`${entity}`]: [query] });
  };
  return (
    <div>
      <AutoComplete
        value={query}
        options={options}
        placeholder={placeholder}
        onSearch={handleInputSearch}
        onSelect={handleInputConfirm}
        style={style ? style : { width: "100%" }}
      >
        <Input
          style={style ? style : { height: "40px" }}
          onPressEnter={handleInputEnter}
        />
      </AutoComplete>
      <div className="keywords">
        {filters[`${entity}`] &&
          filters[`${entity}`].map((key) => tagRender(key))}
      </div>
    </div>
  );
};

export default AutoCompleteFiltersInput;
